import { ContactSupportDialogSectionType, ContactSupportOptionType } from './fi-contact-support-dialog.component';
import { Directive, ElementRef, EventEmitter, Injector, Output } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiSignalRHelperService } from '@fi-shared/fi-signal-r/fi-signal-r-helper.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiSupportService } from '@fi-shared/fi-support/fi-support.service';
import { FiSpinnerService } from '@fi-shared/fi-spinner/fi-spinner.service';

@Directive()
export class FiContactSupportSectionBase {
    @Output() onCloseDialog = new EventEmitter<void>();
    @Output() onGoBack = new EventEmitter<void>();
    @Output() openChatConversation = new EventEmitter<void>();
    appTextService: AppTextService;
    customerDataService: FiCustomerDataService;
    userDataService: FiUserDataService;
    fiSignalHelperRService: FiSignalRHelperService;
    fiSpinnerService: FiSpinnerService;
    supportService: FiSupportService;

    protected currentUserSupportManager: boolean;

    constructor(protected injector: Injector) {
        this.appTextService = this.injector.get(AppTextService);
        this.customerDataService = this.injector.get(FiCustomerDataService);
        this.userDataService = this.injector.get(FiUserDataService);
        this.fiSignalHelperRService = this.injector.get(FiSignalRHelperService);
        this.fiSpinnerService = this.injector.get(FiSpinnerService);
        this.supportService = this.injector.get(FiSupportService);

        this.currentUserSupportManager = this.supportService.isCurrentUserSupportManager();
    }

    closeDialog() {
        this.onCloseDialog.emit();
    }

    goBack() {
        this.onGoBack.emit();
    }

    setCurrentSupportSectionType(newType: ContactSupportDialogSectionType) {
        this.supportService.setCurrentSupportSection(newType);
    }

    setCurrentSupportOptionType(newType: ContactSupportOptionType) {
        this.supportService.setCurrentSupportOptionType(newType);
    }
}
